import React, { useState, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Spin, Form, Input, Button } from 'antd';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import Message from '../../component/message/message';
import trans from './translation';
import './forgotUserID.css';

import loginLogoImg from '../../public/img/loginLogo.png';

const ForgotUserID = (props) => {

    const history = useHistory();
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        if(!Base.stopClick(2000) || loading) {
            return;
        }
        messageShowHandler();
        setLoading(true);
        fetch(Config.apiServer + "forgotUser/forgotUserID", {
            method: 'POST',
            body: JSON.stringify(values.email ?? ''),
            headers: Config.headers,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                form.resetFields();
                errFrameShow("success", trans.send[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setLoading(false));
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    return (
        <div className='forgotUserID'>
            <div className='logoBox'>
            <img src={loginLogoImg} />
                <div className='helpLoginBtn sysUpdate' onClick={() => history.replace("/login")}>{trans.login[Config.backLang]}</div>
            </div>
            <div className='line'></div>
            <div className='forgotUserIDBackground'>
                {/* 错误信息弹框 */}
                <div className='forgotUserIDMessageBox'>
                    <Message ref={messageRef} />
                </div>
                <Spin spinning={loading}>
                    <div className='forgotUserIDBox'>
                        <div className="textBox">
                            <Form form={form} onFinish={onFinish}>
                                <div className='forgotUserIDTitleTop'>{trans.forgotUserID[Config.backLang]}</div>
                                <div className='forgotUserIDInfo'>{trans.forgotUserIDStaff[Config.backLang]}</div>
                                <div className='forgotUserIDInfo'>{trans.forgotUserIDStudent[Config.backLang]}</div>
                                <div className='forgotUserIDInfo'>{trans.forgotUserIDPartner[Config.backLang]}</div>
                                <Form.Item
                                    name="email"
                                    rules={[
                                        { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: trans.emailError[Config.backLang] },
                                    ]}
                                >
                                    <Input maxLength={50} style={{ backgroundColor: '#FFFFFF' }} className="forgotUserIDInput" placeholder={trans.email[Config.backLang]} />
                                </Form.Item>

                                <div className='btnBox'>
                                    <Button type="primary" htmlType="submit" className="forgotUserIDSmbBtn" disabled={loading}>{trans.submit[Config.backLang]}</Button>
                                    <Button onClick={() => history.replace("/login")} className="forgotUserIDBackBtn" disabled={loading}>{trans.back[Config.backLang]}</Button>
                                </div>

                            </Form>
                        </div>
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export default ForgotUserID;